module.exports = __webpack_public_path__ + "img/shop3.cab9f61e.png";